import script from "./ExportPPTX.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExportPPTX.vue?vue&type=script&lang=ts&setup=true"

import "./ExportPPTX.vue?vue&type=style&index=0&id=3fef9be0&lang=scss&scoped=true"

import exportComponent from "/Users/foresight/Desktop/foresight/web/PPTist-tauri/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fef9be0"]])

export default __exports__